//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/NXObject.js";
let d=[[[0,"Active",1,0],[0,"AttributeType",0,0],[0,"Inherited",1,0],[0,"Required",0,0],[0,"Title",0,0],[0,"ValueChanged",1,0],[0,"ValueDouble",1,0],[0,"ValueInteger",1,0],[0,"ValueString",1,0]],[[["numStrings","strings"],"GetOptionStrings",{},0,0]],[]];
SPLM.Weld.CharacteristicsValueBuilder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.CharacteristicsValueBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.CharacteristicsValueBuilder.Type = Object.freeze({
    "String" : "String", "Integer" : "Integer", "Double" : "Double", "Option" : "Option", "None" : "None"});

export default SPLM;